if (!customElements.get('tpt-image-input')) {
	customElements.define(
		'tpt-image-input',
		class TptImageInput extends HTMLElement {
			connectedCallback() {
				this.input = this.querySelector('input[type="file"]');
				this.text = this.querySelector('.file-input__text');

				if (!this.input || !this.text) return;

				this.defaultText = this.text.textContent.trim();

				this.input.addEventListener('change', () => this.handleChange());
			}

			handleChange() {
				const { files } = this.input;

				console.log('TEST...');

				if (!files.length) {
					this.classList.remove('has-file');
					this.text.textContent = this.defaultText;
					return;
				}

				console.log(files.length);

				this.classList.add('has-file');

				if (files.length === 1) {
					this.text.textContent = files[0].name;
				} else {
					this.text.textContent = `${files.length} images selected`;
				}
			}
		},
	);
}
